import { call, put, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/note";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import * as types from "./types";
import * as actions from "./action";

function* createNoteSaga({ payload }) {
  const { onSuccess, ...requestPayload } = payload;
  try {
    const response = yield call(apis.createNote, requestPayload);
    yield put(actions.createNoteResponse(response.data.data));
    if (typeof onSuccess === "function") {
      onSuccess(response.data.data);
    }
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

function* getNoteSaga({ payload }) {
  try {
    const response = yield call(apis.getNote, payload.id);
    yield put(actions.getNoteResponse(response.data.data));
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

function* deleteNoteSaga({ payload }) {
  const { onSuccess, id } = payload;
  try {
    yield call(apis.deleteNote, id);
    yield showSuccessMsg("NoteDeletedSuccessfully", true);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

function* updateNoteSaga({ payload }) {
  const { onSuccess, ...requestPayload } = payload;
  try {
    const response = yield call(apis.updateNote, requestPayload);
    yield put(actions.updateNoteResponse(response.data.data));
    yield showSuccessMsg("NoteUpdateSuccessfully", true);
    if (typeof onSuccess === "function") {
      onSuccess(response.data.data);
    }
  } catch (err) {
    yield showErrorMsg(err.response?.data?.message);
  }
}

export default function* NoteSagas() {
  yield takeEvery(types.CREATE_NOTE_REQUEST, createNoteSaga);
  yield takeEvery(types.GET_NOTE_REQUEST, getNoteSaga);
  yield takeEvery(types.DELETE_NOTE_REQUEST, deleteNoteSaga);
  yield takeEvery(types.UPDATE_NOTE_REQUEST, updateNoteSaga);
}
